import {h, Component} from 'preact';
export default class ArrowLeft extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42" width='16' height='16'>
                <path fill={this.props.color} d="M38.35,18H9C11.8,15.21,20,6.9,20.24,6.62c.39-.44,1.39-1.78.18-2.94a2.25,2.25,0,0,0-2.95-.23c-.39.31-15.62,15.43-15.62,15.43a2,2,0,0,0,0,3.18s15,14.82,15.64,15.34a2,2,0,0,0,2.86-.12,2,2,0,0,0-.1-3.06c-.39-.38-8.48-8.54-11.19-11.3H38.35a2.69,2.69,0,0,0,2.48-2.44A2.69,2.69,0,0,0,38.35,18Z"/>
            </svg>
        );
    }
}



// WEBPACK FOOTER //
// ./components/SVGImages/ArrowLeft.js